var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#B3B3B3;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "25.7,10.4 25.7,24.8 32.2,31.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.6,
    y1: 24.8,
    x2: 8.5,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 43,
    y1: 24.8,
    x2: 45.8,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.7,
    y1: 44.9,
    x2: 25.7,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.7,
    y1: 7.5,
    x2: 25.7,
    y2: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.7,47C38,47,48,37.1,48,24.8S38,2.5,25.7,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.7,47c-12.3,0-22.3-10-22.3-22.3c0-4.8,1.5-9.3,4.1-12.9l4-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.1,15.4 12.1,7.5 4.2,7.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1525109e21bac5589ad9a6bbc240f5fe.svg";
export { ForwardRef as ReactComponent };